// src/features/Planning/components/Step9StairType.jsx
import {
  Box,
  Flex,
  Text,
  Radio,
  Button,
  VStack,
  Image,
} from "@chakra-ui/react";
import InteriorStair from "../../../../assets/Planning/StairType/InteriorStair.png";
import ExteriorImage from "../../../../assets/Planning/StairType/ExteriorStair.png";

export default function Step9StairType({
  formData,
  setFormData,
  onNext,
  onSubmit,
  onBack,
  isLastStep,
  viewMode,
}) {
  const stairType = formData.stairType || formData.stair?.type || "";

  const updateStairType = (value) => {
    setFormData((prev) => ({
      ...prev,
      stairType: value,
    }));
  };

  const handleAction = isLastStep ? onSubmit : onNext;

  return (
    <Box
      h="600px"
      w="100%"
      maxW="400px"
      mx="auto"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      px={4}
      py={6}
    >
      {/* ✅ SCROLLABLE CONTENT */}
      <Box
        flex="1"
        minH="0" // 🔥 important fix
        overflowY="auto"
        overflowX="hidden"
        pr={2}
        css={{
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#cbd5e0",
            borderRadius: "10px",
          },
          "& *": { pointerEvents: viewMode ? "none" : "auto" },
        }}
      >
        <VStack spacing={4} align="stretch">
          {/* Title */}
          <Box textAlign="center">
            <Text fontSize="17px" fontWeight="600" color="gray.800">
              Stair Type
            </Text>
            <Text fontSize="12px" color="gray.500" mt={1}>
              Choose whether your stairs should be inside the house or outside.
            </Text>
          </Box>

          {/* Internal Stair */}
          <Box
            borderRadius="10px"
            overflow="hidden"
            border={
              stairType === "internal"
                ? "2px solid #319795"
                : "1px solid #E2E8F0"
            }
            onClick={() => updateStairType("internal")}
            cursor="pointer"
            transition="0.2s"
            _hover={{ borderColor: "cyan.400" }}
          >
            <Image
              src={InteriorStair}
              w="100%"
              h="140px"
              objectFit="cover"
            />

            <Flex align="center" px={3} py={2}>
              <Radio
                value="internal"
                colorScheme="cyan"
                isChecked={stairType === "internal"}
                onChange={() => updateStairType("internal")}
              />
              <Box ml={2}>
                <Text fontSize="14px" fontWeight="600" color="gray.800">
                  Internal Staircase
                </Text>
                <Text fontSize="11px" color="gray.500">
                  Located inside the house for private access
                </Text>
              </Box>
            </Flex>
          </Box>

          {/* External Stair */}
          <Box
            borderRadius="10px"
            overflow="hidden"
            border={
              stairType === "external"
                ? "2px solid #319795"
                : "1px solid #E2E8F0"
            }
            onClick={() => updateStairType("external")}
            cursor="pointer"
            transition="0.2s"
            _hover={{ borderColor: "cyan.400" }}
          >
            <Image
              src={ExteriorImage}
              w="100%"
              h="140px"
              objectFit="cover"
            />

            <Flex align="center" px={3} py={2}>
              <Radio
                value="external"
                colorScheme="cyan"
                isChecked={stairType === "external"}
                onChange={() => updateStairType("external")}
              />
              <Box ml={2}>
                <Text fontSize="14px" fontWeight="600" color="gray.800">
                  External Staircase
                </Text>
                <Text fontSize="11px" color="gray.500">
                  Located outside for independent floor access
                </Text>
              </Box>
            </Flex>
          </Box>

          {/* Tip */}
          <Box
            bg="gray.50"
            borderRadius="8px"
            px={3}
            py={2}
            fontSize="11px"
            color="gray.600"
            textAlign="center"
          >
            Tip: External stairs are ideal for rental floors. Internal stairs
            are better for family use
          </Box>
        </VStack>
      </Box>

      {/* ✅ BUTTONS (EXACT SAME AS OTHER STEPS) */}
      <Flex justify="space-between" gap={3} mt={4} flexShrink={0}>
        <Button
          onClick={onBack}
          variant="solid"
          bg="white"
          color="cyan.600"
          border="1px solid"
          borderColor="cyan.500"
          borderRadius="6px"
          minW="100px"
          h="40px"
          fontWeight="500"
          fontSize="14px"
          _hover={{
            bg: "cyan.50",
            borderColor: "cyan.600",
          }}
        >
          ← Previous
        </Button>

        <Button
          onClick={handleAction}
          variant="solid"
          bg="cyan.500"
          color="white"
          borderRadius="6px"
          minW="100px"
          h="40px"
          fontWeight="500"
          fontSize="14px"
          ml="auto"
          _hover={{
            bg: "cyan.600",
          }}
        >
          {isLastStep ? "Submit" : "Next →"}
        </Button>
      </Flex>
    </Box>
  );
}